import type { SVGProps } from 'react';

const SvgPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m19.71 9.29-5-5c-.23-.23-.55-.33-.87-.28s-.59.25-.73.54l-.93 1.85-2.67 2.67-4.7.94a1.002 1.002 0 0 0-.51 1.69l3.29 3.29-3.29 3.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3.29-3.29 3.29 3.29c.19.19.45.29.71.29.1 0 .19-.01.29-.04.35-.11.62-.4.69-.76l.94-4.7 2.67-2.67 1.85-.93a.99.99 0 0 0 .54-.73c.05-.31-.05-.64-.28-.87zm-3.16.82c-.1.05-.18.11-.26.19l-3 3c-.14.14-.23.32-.27.51l-.63 3.17-5.36-5.36 3.17-.63c.19-.04.37-.13.51-.27l3-3c.08-.08.14-.16.19-.26l.38-.76 3.04 3.04-.76.38z"
    />
  </svg>
);
export default SvgPin;
